import { CommunitiesStateType, CommunityType } from './types';

import { CommunitiesActionType, Pagination } from 'enums';
import { CommunitiesActionReturnType } from 'state/actions';

const initState: CommunitiesStateType = {
  isLoading: false,
  communities: [],
  search: '',
  page: Pagination.START_PAGE,
  certainCommunity: {} as CommunityType,
};

export const communitiesReducer = (
  // eslint-disable-next-line default-param-last
  state: CommunitiesStateType = initState,
  action: CommunitiesActionReturnType,
): CommunitiesStateType => {
  switch (action.type) {
    case CommunitiesActionType.SET_COMMUNITIES:
      return { ...state, communities: action.communities };
    case CommunitiesActionType.SET_COMMUNITIES_AFTER_SCROLL:
      return { ...state, communities: [...state.communities, ...action.communities] };
    case CommunitiesActionType.SEARCH_COMMUNITIES:
      return { ...state, search: action.search };
    case CommunitiesActionType.SET_COMMUNITIES_PAGINATION:
      return { ...state, count: action.pagination.count, page: action.pagination.page };
    case CommunitiesActionType.SET_COMMUNITIES_LOADING_STATUS:
      return { ...state, isLoading: action.isLoading };
    case CommunitiesActionType.SET_CERTAIN_COMMUNITY:
      return { ...state, certainCommunity: action.community };
    default:
      return state;
  }
};
